import * as React from "react";
const SvgOpenLink = (props) => /* @__PURE__ */ React.createElement("svg", { width: 10, height: 10, viewBox: "0 0 10 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1.0675 0V1.77662H6.95402L0 8.88311L1.06757 10L8.2135 3.02914V8.88311H10V0H1.0675Z", fill: "black" }));
export default SvgOpenLink;
